<template>
    <div class="summaryPair-row">
        <div class="summaryPair-item">
            {{symbol}}
        </div>
        <div class="summaryPair-item">
            {{profitPercent}}
        </div>
        <div class="summaryPair-item">
            {{profitPips}}
        </div>
        <div class="summaryPair-item">
            {{percentDeals}}
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
    props: {
        symbol:{default:'EURUSD'}
    },
    data() {
        return {
            profitPercent:0,
            profitPips:0,
            percentDeals:0,
            countDeals:0,
            statistics:0
        }
    },
    computed: {
        ...mapGetters({
            getStatistics: 'accountstat/getStatistics'
        }
        ),

    },
    methods: {
        updateChart() {
            let stat = this.getStatistics(this.symbol);
            if (!stat) {
                return;
            }
            this.statistics = stat;
            this.countDeals = this.statistics.Summary.TotalDeals;
            this.profitDeals = this.statistics.Summary.ProfitableDeals;
            this.profitPercent = this.statistics.Summary.Twr;
            this.profitPips = this.statistics.Summary.ProfitPoints;
            this.percentDeals = (100/(this.countDeals/this.profitDeals)).toFixed(2);
        },
    },
    created() {
        subscribeOnUpdate(this.$store, this.symbol, isFirstObtained => {
            //if (!this.symbol || !this.symbol.length) {
                this.updateChart(this.symbol);
            //}
        });
        // может быть, данные уже есть в store
        this.updateChart(this.symbol);
    }
}
function subscribeOnUpdate(store, symbol, handler) {
    store.dispatch("accountstat/subscribeOnUpdate", {
        symbol: symbol,
        callback: {
            id: `summary-pair-signals-${symbol}`,
            handler: handler
        }
    });

}
</script>
<style lang="less" scoped>
.summaryPair {
    &-row {
        display:flex;
        width:100%;
        justify-content: space-between;
        border-bottom:1px solid #374b62;
        color:#9FB6D2;
    }
    &-item {
        font-family: Arimo;
        font-size: 12px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 2.33;
        width: 80px;
        border-right: 1px solid #374b62;
        text-align: center;
        &:first-child {
            
        }
        &:last-child {
           
            width: 120px;
        }
    }
}
</style>
